import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AvatarNext } from 'src/components/AvatarNext';
import { CompetitorOutcome } from '../../CompetitorOutcome';
import { truncateIfTooLong } from 'src/util/truncate';
import { useMatch } from '../MatchProvider';
import { SxProps } from '@mui/material';
import { MatchCompetitor } from './MatchDetails';

export type MatchDetailsCompetitorProps = {
  competitor: MatchCompetitor;
  showStatus: boolean;
  sx?: SxProps;
  innerSx?: SxProps;
};

export const MatchDetailsCompetitor = ({
  competitor,
  showStatus,
  innerSx,
  sx,
}: MatchDetailsCompetitorProps) => {
  const { status } = useMatch();
  const { name, avatarUrl, score, outcome } = competitor;
  const teamResult = showStatus && (score || outcome);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '50%',
        flexDirection: 'row',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 3,
          ...innerSx,
        }}
      >
        {!!name && (
          <>
            <AvatarNext src={avatarUrl} />
            <Typography variant="body1" color="text.primary">
              {truncateIfTooLong(name)}
            </Typography>
          </>
        )}
      </Box>
      {teamResult && (
        <CompetitorOutcome
          outcome={outcome}
          status={!!status ? status : 'inactive'}
          score={score}
        />
      )}
    </Box>
  );
};
